import { render, staticRenderFns } from "./transfer_locations.vue?vue&type=template&id=90dcb416&vue3"
import script from "./transfer_locations.vue?vue&type=script&lang=js&vue3"
export * from "./transfer_locations.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports